import { Alert, Box, Button, GlobalStyles, Snackbar, Stack, styled, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { ReturnButton } from './styled-components';
import Grid from '@mui/material/Unstable_Grid2';
import { useAppSelector } from '../utils/hooks';
import { getEmbeddedLprScanner } from '../modules/layout/selectors';
import { useTranslation } from 'react-i18next';
import { ButtonColor } from '../layout/colors';

export const InputField = styled(TextField)({
  maxHeight: 140,
  variant: 'outlined',
  width: '100%',
  borderColor: 'white',
  '& input': {
    fontSize: '3.75rem',
    color: 'white',
    border: '2px solid white',
    textTransform: 'uppercase',
  },
});

export const SearchButton = styled(Button)({
  backgroundColor: ButtonColor.Green,
  color: 'white',
  '&:hover': {
    backgroundColor: ButtonColor.GreenHover,
  },
  borderRadius: '8px',
  fontWeight: 800,
  fontSize: '2rem',
  maxHeight: '120px',
  height: '120px',
  width: '100%',
});

interface PlateFormProps {
  handleReturn: () => void;
  handleConfirm: (plate: string) => void;
  confirmButtonText: string;
  bgColor?: string;
  children?: JSX.Element;
}

const PlateForm = ({ handleReturn, handleConfirm, confirmButtonText, bgColor, children }: PlateFormProps) => {
  const { t } = useTranslation(['common']);
  const [openError, setoOpenError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [plate, setPlate] = useState<string>('');
  const embeddedLprScanner = useAppSelector((x) => getEmbeddedLprScanner(x.layout));

  const handleSubmit = (e) => {
    e.preventDefault();
  };
  const displayError = (message: string): void => {
    setErrorMessage(message);
    setoOpenError(true);
  };

  const handleSearchClick = () => {
    if (plate.length === 0) {
      displayError(t('common:plates.enterPlateNumberErrorMessage'));
      return;
    }
    if (plate.length < 3) {
      displayError(t('common:plates.tooShortPlateNumberErrorMessage'));
      return;
    }
    handleConfirm(plate);
  };

  const handleOpenCameraPlateReader = () => {
    if (window.BtDevice) {
      window.BtDevice.startLprScan();
      window.BtApp.handleLprScan = (plate: string) => {
        console.log('Zeskanowano: ' + plate);
        if (plate !== undefined) {
          setPlate(plate);
        }
      };
    }
  };

  return (
    <>
      <GlobalStyles
        styles={{
          body: { backgroundColor: bgColor ? bgColor : '#6260A8' },
          html: { backgroundColor: bgColor ? bgColor : '#6260A8' },
        }}
      />
      <form onSubmit={handleSubmit}>
        <Stack direction="column" spacing={6} sx={{ py: 6, backgroundColor: bgColor ? bgColor : '#6260A8' }}>
          <ReturnButton onClick={handleReturn}>
            <>{t('common:buttons.back')}</>
          </ReturnButton>
          <Typography sx={{ fontSize: '1.875rem', lineHeight: '3.2rem', color: 'white', px: 2, textAlign: 'center' }}>
            {t('common:plates.enterPlateNumber').toString()}
          </Typography>
          <Grid container rowSpacing={2}>
            <Grid xs={12} md={embeddedLprScanner ? 11 : 12}>
              <InputField
                autoFocus={!embeddedLprScanner}
                onChange={(e) => setPlate(e.target.value)}
                value={plate}
              ></InputField>
            </Grid>
            {embeddedLprScanner && (
              <Grid xs={3} md={1} alignSelf="center">
                <Button onClick={handleOpenCameraPlateReader}>
                  <Box component="img" src="/images/camera_scanner.png" justifyContent="center"></Box>
                </Button>
              </Grid>
            )}
            <Grid xs={embeddedLprScanner ? 9 : 12} md={4} mdOffset={4}>
              <SearchButton onClick={() => handleSearchClick()} sx={{ alignSelf: 'center' }} type="submit">
                {confirmButtonText}
              </SearchButton>
            </Grid>
          </Grid>
        </Stack>
      </form>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={openError}
        onClose={() => setoOpenError(false)}
        autoHideDuration={3000}
      >
        <Alert onClose={() => setoOpenError(false)} severity="error" sx={{ width: '100%' }}>
          {errorMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default PlateForm;
